/**
 * Footer: Handle the form submit button depending on 'Over 18' checkbox
 * value and the email input value.
 */
export function handleSubmitButton(): void {
	const submitButton = document.querySelector('#footer__newsletter-submit') as HTMLButtonElement;
	const over18 = document.querySelector('#footer__newsletter-over18') as HTMLInputElement;
	const email = document.querySelector('#footer__newsletter-input') as HTMLInputElement;
	if (!over18) return;

	over18.addEventListener('change', function () {
		if (over18.checked && email.value) {
			submitButton.classList.remove('disabled', 'shake');
		} else {
			submitButton.classList.add('disabled');
		}
	});

	email.addEventListener('keyup', function () {
		if (over18.checked && email.value) {
			submitButton.classList.remove('disabled');
		} else {
			submitButton.classList.add('disabled');
		}
	});
}

/**
 * Add animation to submit button if form isn't ready to submit, to better tell the user
 * that something needs actioning.
 */
export function animateDisabledButton(): void {
	const submitButton = document.querySelector('#footer__newsletter-submit') as HTMLButtonElement;
	if (!submitButton) return;

	submitButton.addEventListener('click', function () {
		if (submitButton && submitButton.classList.contains('disabled')) {
			submitButton.classList.add('shake');

			submitButton.addEventListener('animationend', function onAnimationEnd() {
				submitButton.classList.remove('shake');
				submitButton.removeEventListener('animationend', onAnimationEnd); // Cleanup
			});
		}
	});
}

/**
 * Handles the response from submitting the newsletter signup form.
 */
export function submitNewsletterForm(): void {
	const form = document.querySelector('#footer__newsletter') as HTMLFormElement;
	const email = document.querySelector('#footer__newsletter-input') as HTMLInputElement;
	const over18 = document.querySelector('#footer__newsletter-over18') as HTMLInputElement;
	if (!form && !email && !over18) return;

	form.addEventListener('submit', function (event) {
		event.preventDefault();
		if (email.value && over18.checked) {
			const csrfToken =
				document.querySelector('meta[name="_csrf"]')?.getAttribute('content') || '';
			const csrfHeader =
				document.querySelector('meta[name="_csrf_header"]')?.getAttribute('content') || '';
			const base = window.serverData?.contextPath || '';
			fetch(`${base}/et/addToList/newsletter?email=${encodeURIComponent(email.value)}`, {
				method: 'POST',
				headers: {
					[csrfHeader]: csrfToken,
				},
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(`Request failed with status ${response.status}`);
					}
				})
				.then((data) => {
					form.innerHTML = `
                    <span id="footer__newsletter-success">Thanks for signing up!</span>
                `;
					console.log('Success:', data);
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		}
	});
}
